import { useAppScopeStore } from '@frontend/scope';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { GeneralSettings } from '../sections/general-settings';

export const GeneralSettingsGroup = () => {
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard locationId={locationIds[0]}>
          <GeneralSettings />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup showManageAllToggle>
          <GeneralSettings />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};
